import { retrieveToken } from '../storage';
import { wrapFetch, apiFetch, apiError } from './api';
import { SESSION_EXPIRED_HOME_MESSAGE } from '../handleInvalidToken';

const BASE_URL = process.env.REACT_APP_BACKEND_ENDPOINT;

export const getCountAbbonamenti = (gruppoId, consulenteId, esercizioId) => {
  const token = retrieveToken();
  const PATH = '/api/abbonamenti/count';
  const params = [];
  if (gruppoId !== null && gruppoId !== -1) {
    params.push('gruppoId.equals=' + gruppoId);
  }
  if (consulenteId !== null) {
    params.push('consulenteId.equals=' + consulenteId);
  }
  if (esercizioId !== null) {
    params.push('esercizioCommercialeId.equals=' + esercizioId);
  }
  const URL =
    BASE_URL + PATH + (params.length > 0 ? `?${params.join('&')}` : '');
  const authtoken = 'Bearer '.concat(token);
  return wrapFetch(
    apiFetch(URL, {
      method: 'GET',
      headers: {
        Authorization: authtoken,
      },
      withCredentials: true,
      credentials: 'include',
    }),
    apiError({
      403: SESSION_EXPIRED_HOME_MESSAGE,
    }),
  );
};

export const getAbbonamenti = (
  gruppoId,
  consulenteId,
  esercizioId,
  page,
  size,
  sortby,
) => {
  const token = retrieveToken();
  const PATH = '/api/abbonamenti';
  let query =
    '?' +
    'page=' +
    page +
    '&size=' +
    size +
    '&sort=' +
    sortby +
    '&' +
    sortby +
    '.dir=ASC';
  if (gruppoId !== null && gruppoId !== -1) {
    query = query + '&gruppoId.equals=' + gruppoId;
  }
  if (consulenteId !== null) {
    query = query + '&consulenteId.equals=' + consulenteId;
  }
  if (esercizioId !== null) {
    query = query + '&esercizioCommercialeId.equals=' + esercizioId;
  }
  const URL = BASE_URL + PATH + query;
  const authtoken = 'Bearer '.concat(token);
  return wrapFetch(
    apiFetch(URL, {
      method: 'GET',
      headers: {
        Authorization: authtoken,
      },
      withCredentials: true,
      credentials: 'include',
    }),
    apiError({
      403: SESSION_EXPIRED_HOME_MESSAGE,
    }),
  );
};

export const getCountAbbonamentiFiltered = (
  gruppoId,
  consulenteId,
  esercizioId,
  idAbbonamento,
  ragioneSociale,
  stato,
) => {
  const token = retrieveToken();
  const PATH = '/api/abbonamenti';
  const params = [];
  if (gruppoId !== null && gruppoId !== -1) {
    params.push('gruppoId.equals=' + gruppoId);
  }
  if (consulenteId !== null && consulenteId !== '') {
    params.push('consulenteId.equals=' + consulenteId);
  }
  if (esercizioId !== null && esercizioId !== '') {
    params.push('esercizioCommercialeId.equals=' + esercizioId);
  }
  if (idAbbonamento !== null && idAbbonamento !== '') {
    params.push('id.equals=' + idAbbonamento);
  }
  if (stato !== null && stato !== '') {
    params.push('stato.equals=' + stato);
  }
  if (ragioneSociale !== null && ragioneSociale !== '') {
    params.push(
      `ragioneSociale.contains=${encodeURIComponent(ragioneSociale)}`,
    );
  }
  const URL =
    BASE_URL +
    PATH +
    '/count' +
    (params.length > 0 ? `?${params.join('&')}` : '');
  const authtoken = 'Bearer '.concat(token);
  return wrapFetch(
    apiFetch(URL, {
      method: 'GET',
      headers: {
        Authorization: authtoken,
      },
      withCredentials: true,
      credentials: 'include',
    }),
    apiError({
      403: SESSION_EXPIRED_HOME_MESSAGE,
    }),
  );
};

export const getAbbonamentiFiltered = (
  gruppoId,
  consulenteId,
  esercizioId,
  page,
  size,
  sortby,
  idAbbonamento,
  ragioneSociale,
  stato,
) => {
  const token = retrieveToken();
  const PATH = '/api/abbonamenti';
  let query =
    '?' +
    'page=' +
    page +
    '&size=' +
    size +
    '&sort=' +
    sortby +
    '&' +
    sortby +
    '.dir=ASC';
  if (gruppoId !== null && gruppoId !== -1) {
    query = query + '&gruppoId.equals=' + gruppoId;
  }
  if (consulenteId !== null && consulenteId !== '') {
    query = query + '&consulenteId.equals=' + consulenteId;
  }
  if (esercizioId !== null && esercizioId !== '') {
    query = query + '&esercizioCommercialeId.equals=' + esercizioId;
  }
  if (idAbbonamento !== null && idAbbonamento !== '') {
    query = query + '&id.equals=' + idAbbonamento;
  }
  if (stato !== null && stato !== '') {
    query = query + '&stato.equals=' + stato;
  }
  if (ragioneSociale !== null && ragioneSociale !== '') {
    query += `&ragioneSociale.contains=${encodeURIComponent(ragioneSociale)}`;
  }
  const URL = BASE_URL + PATH + query;
  const authtoken = 'Bearer '.concat(token);
  return wrapFetch(
    apiFetch(URL, {
      method: 'GET',
      headers: {
        Authorization: authtoken,
      },
      withCredentials: true,
      credentials: 'include',
    }),
    apiError({
      403: SESSION_EXPIRED_HOME_MESSAGE,
    }),
  );
};

export const registerPagamento = (requestBody) => {
  const token = retrieveToken();
  const PATH = '/api/abbonamenti/pagamenti/registrazione';
  const URL = BASE_URL + PATH;
  const authtoken = 'Bearer '.concat(token);
  return wrapFetch(
    apiFetch(URL, {
      method: 'POST',
      headers: {
        Authorization: authtoken,
        'Content-Type': 'application/json',
      },
      withCredentials: true,
      credentials: 'include',
      body: JSON.stringify(requestBody),
    }),
    apiError({
      400: 'Registrazione del pagamento non riuscita: dati non corretti.',
      403: SESSION_EXPIRED_HOME_MESSAGE,
    }),
  );
};
